module.exports = function() {
  return new Worker(__webpack_public_path__ + "317a6fbe643616970638.worker.js");
};